<section id="testimonials" class="tst-section">
  <!-- Decorative layer -->
  <div class="tst-bg">
    <div class="tst-grid-pattern"></div>
    <div class="tst-orb tst-orb-1"></div>
    <div class="tst-orb tst-orb-2"></div>
  </div>

  <!-- Header -->
  <div class="tst-head reusable-container">
    <div class="tst-head-left">
      <div class="tst-eyebrow">
        <span class="dot"></span>
        Voices from our institutions
      </div>
      <h2 class="tst-title">
        <span class="line-1">Not just software.</span><br />
        <span class="accent">A standard they trust.</span>
      </h2>
    </div>

    <div class="tst-head-chips">
      <div class="tst-chip">
        <mat-icon>verified</mat-icon>
        <div>
          <strong>30+ agencies</strong>
          <span>onboarded</span>
        </div>
      </div>
      <div class="tst-chip tst-chip-accent">
        <mat-icon>star</mat-icon>
        <div>
          <strong>4.9 / 5</strong>
          <span>avg. rating</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Hero stage -->
  <div class="tst-stage reusable-container">
    <!-- Side bracket number -->
    <div class="tst-bracket">
      <div class="tst-bracket-num">
        {{ (selectedIndex + 1).toString().padStart(2, '0') }}
      </div>
      <div class="tst-bracket-line"></div>
      <div class="tst-bracket-total">
        of {{ testimonies.length.toString().padStart(2, '0') }}
      </div>
    </div>

    <!-- Dark featured card -->
    <article class="tst-hero" [attr.data-active]="selectedIndex">
      <div class="tst-hero-mesh"></div>
      <div class="tst-hero-grain"></div>

      <!-- Floating seal that breaks the edge -->
      <div class="tst-hero-seal">
        <div class="tst-hero-seal-ring"></div>
        <div class="tst-hero-seal-inner">
          <img [src]="active.logo" alt="" />
        </div>
        <div class="tst-hero-seal-badge">
          <mat-icon>check</mat-icon>
        </div>
      </div>

      <div class="tst-hero-mark">"</div>

      <div class="tst-hero-rating">
        @for (s of stars(active.rating); track $index) {
          <mat-icon>star</mat-icon>
        }
        <span class="tst-hero-rating-label">Verified feedback</span>
      </div>

      <blockquote class="tst-hero-quote">
        {{ active.content }}
      </blockquote>

      <div class="tst-hero-foot">
        <div class="tst-hero-author">
          <div class="tst-hero-name">{{ active.name }}</div>
          <div class="tst-hero-role">
            <span>{{ active.role }}</span>
            <span class="dot-sep"></span>
            <span>{{ active.institution }}</span>
          </div>
        </div>

        <div class="tst-hero-nav">
          <button class="tst-nav-btn"
                  (click)="select((selectedIndex - 1 + testimonies.length) % testimonies.length)"
                  aria-label="Previous">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <button class="tst-nav-btn primary"
                  (click)="select((selectedIndex + 1) % testimonies.length)"
                  aria-label="Next">
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      </div>
    </article>
  </div>

  <!-- Portrait pill navigation -->
  <div class="tst-pills reusable-container">
    @for (t of testimonies; track t.id) {
      <button class="tst-pill"
              [class.active]="selectedIndex === $index"
              (click)="select($index)">
        <div class="tst-pill-logo">
          <img [src]="t.logo" alt="" />
        </div>
        <div class="tst-pill-text">
          <div class="tst-pill-name">{{ t.name }}</div>
          <div class="tst-pill-inst">{{ t.institution }}</div>
        </div>
        <span class="tst-pill-marker"></span>
      </button>
    }
  </div>

  <!-- Logo marquee strip -->
  <div class="tst-logos">
    <span class="tst-logos-label">Powering meetings for</span>
    <div class="tst-logos-track">
      @for (logo of logos; track $index) {
        <div class="tst-logo"><img [src]="logo" alt="" /></div>
      }
      @for (logo of logos; track $index + '-d') {
        <div class="tst-logo" aria-hidden="true"><img [src]="logo" alt="" /></div>
      }
    </div>
  </div>
</section>
